import Vue from 'vue'
import Router from 'vue-router'
import MainPage from '@/components/MainPage'

import login from '@/components/login/login'
import register from '@/components/login/register'
import modifyPassword from '@/components/login/modifyPassword'
import xieyi from '@/components/login/xieyi'
import vip from '@/components/login/vip'
import order from '@/components/login/order'
import changePhone from '@/components/login/changePhone'
import download from '@/components/login/download'

import OneKey from '@/components/OneKey'
import collections from '@/components/collections'
import UserCenter from '@/components/UserCenter'

import news from '@/components/news/news'
import knowEarly from '@/components/news/knowEarly'

import test from '@/components/test/test'

import collegeList from '@/components/college/collegeList'
import college from '@/components/college/college'
import majorTypes from '@/components/college/majorTypes'


import score from '@/components/student/score'
import overview from '@/components/student/overview'
import phase from '@/components/student/phase'
import province from '@/components/student/province'
import risk from '@/components/student/risk'
import major from '@/components/student/major'
import intention from '@/components/student/intention'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/', component: MainPage,meta:{title:'主页'}
    },
    {
      path: '/MainPage',   component: MainPage,meta:{title:'主页'}
    },
    {
      path: '/login/login',   component: login,meta:{title:'登录'}
    },
    {
      path: '/login/register',   component: register,meta:{title:'注册'}
    },
    {
      path: '/login/modifyPassword',   component: modifyPassword,meta:{title:'修改密码'}
    },
    {
      path: '/login/xieyi',   component: xieyi,meta:{title:'使用协议'}
    },
    { path: '/login/vip',  component: vip,meta:{title:'开通VIP'}},
    { path: '/login/order',  component: order,meta:{title:'专家预约'}},
    { path: '/login/changePhone',  component: changePhone,meta:{title:'更换手机'}},
    { path: '/login/download',  component: download,meta:{title:'下载志愿'}},

    {
      path: '/OneKey',   component: OneKey,meta:{title:'一键志愿'}
    },
    {path: '/collections',    component: collections,meta:{title:'志愿决策'} },
    {
      path: '/UserCenter',  component: UserCenter,meta:{title:'用户中心'}

    }, {
      path: '/student/score',  component: score,meta:{title:'高考分数'}
    }, {
      path: '/student/overview',  component: overview,meta:{title:'基本概况'}
    },
    { path: '/student/phase',  component: phase,meta:{title:'段次选择'}},
    { path: '/student/province',  component: province,meta:{title:'区域选择'}},
    { path: '/student/risk',  component: risk,meta:{title:'冲稳保选择'}},
    { path: '/student/major',  component: major,meta:{title:'专业选择'}},
    { path: '/student/intention',  component: intention,meta:{title:'志愿选择'}},

    { path: '/news/knowEarly',  component: knowEarly,meta:{title:'录取早知道'}},
    {
      path: '/news/news/:id', name: 'news',    component: news,meta:{title:'新闻'}
    },{
      path: '/test/test', component: test,meta:{title:'自我评测'}
    },
    {
      path: '/college/collegeList',   component: collegeList,meta:{title:'高校风采'}
    },
    {
      path: '/college/college/:id',component: college,meta:{title:'高校简介'}
    },
    { path: '/college/majorTypes',  component: majorTypes,meta:{title:'专业探索'}}
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js